export default {
    aboutUs: 'About',
    support: 'Support',
    contactUs: 'Contact Us',
};